import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { PtTaxId } from './PortugalFields/TaxId'

export const EmployeeInfoPreview = () => {
  const { company } = useCurrentSession()

  const mainCountry = company.legalEntities.find((legalEntity) => legalEntity.main)?.country

  return (
    <>
      <Box paddingTop="s16" paddingBottom="s8">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.title')}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.description')}
          </Text.Normal>
        </Box>
      </Box>

      <Box padding="s24" gap="s24" background="grey200" borderRadius={{ all: 'abs008' }}>
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s24">
          <Box width="s300" gap="s4">
            <Text.Normal size="200" weight="medium" color="grey1000">
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_id.preview.id_document'
              )}
            </Text.Normal>
            <Box
              background="grey000White"
              padding="s12"
              borderRadius={{ all: 'abs008' }}
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
            >
              <Text.Normal color="grey800">
                {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.dni')}
              </Text.Normal>
              <Icon.Small icon="caret-down" color="grey800" />
            </Box>
          </Box>
          <Box width="s300" gap="s4">
            <Text.Normal size="200" weight="medium" color="grey1000">
              {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.id_number')}
            </Text.Normal>
            <Box
              background="grey000White"
              padding="s12"
              borderRadius={{ all: 'abs008' }}
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
            >
              <Text.Normal color="grey600">
                {i18n.t(
                  'processes.process_settings.wizard.tasks.types.request_id.preview.write_id_number'
                )}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
        <Box gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.request_id.preview.social_security'
            )}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s12"
            borderRadius={{ all: 'abs008' }}
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey600">
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_id.preview.write_social_security'
              )}
            </Text.Normal>
          </Box>
        </Box>

        <PtTaxId />
      </Box>
    </>
  )
}
